<tui-loader [loading]="busy" [overlay]="true">
	<section tuiContent>
		<div tuiNotification class="mb-8 mt-[-12px]" appearance="info">
			{{ 'analyses.dialog.edit-analysis.update-warning' | transloco }}
		</div>

		@if (form) {
			<form [formGroup]="form" class="gap-10">
				<div class="flex gap-10 max-w-sm">
					<label tuiLabel class="w-0 flex-1">
						{{
							'analyses.dialog.edit-analysis.name-analysis'
								| transloco
						}}

						<tui-textfield tuiTextfieldSize="m">
							<input
								[placeholder]="
									'analyses.dialog.create-analysis.name-placeholder'
										| transloco
								"
								formControlName="name"
								tuiInput
								type="text"
							/>
						</tui-textfield>

						<tui-error
							[order]="['required']"
							formControlName="name"
						/>
					</label>
				</div>

				<label tuiLabel class="w-full max-w-56">
					{{ 'currency.label' | transloco }}

					<tui-textfield
						tuiChevron
						tuiTextfieldSize="m"
						[tuiTextfieldCleaner]="false"
						[content]="currencyContent"
					>
						<input
							formControlName="currency"
							tuiSelect
							[placeholder]="'currency.placeholder' | transloco"
						/>

						<tui-data-list-wrapper
							new
							*tuiDropdown
							[items]="currencies"
							[itemContent]="currencyContent"
						/>

						<ng-template #currencyContent let-value>
							{{ 'currency.' + value | transloco }}
						</ng-template>
					</tui-textfield>

					<tui-error
						[order]="['required']"
						formControlName="currency"
					/>
				</label>

				@if (currencyChanged) {
					<div tuiNotification appearance="info">
						{{
							'analyses.dialog.edit-analysis.currency-notice'
								| transloco
						}}
					</div>
				}

				@if (timePeriods) {
					@for (time of timePeriods.controls; track time) {
						@if (timePeriods.at($index); as formGroup) {
							<div
								class="flex gap-10"
								[formGroup]="$any(formGroup)"
							>
								<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
								<label tuiLabel class="flex-1">
									{{
										'analyses.dialog.edit-analysis.time-period.min-date'
											| transloco: { count: $index + 1 }
									}}

									<tui-textfield tuiTextfieldSize="m">
										<input
											tuiInputDate
											formControlName="minDate"
											[max]="
												formGroup.get('maxDate')
													?.value ?? maxDate
											"
											[min]="
												$first
													? null
													: (timePeriods
															.at($index - 1)
															.get('maxDate')
															?.value ?? minDate)
											"
											placeholder="{{
												'analyses.dialog.create-analysis.time-period.date-placeholder'
													| transloco
											}}"
										/>
										<tui-calendar *tuiDropdown />
									</tui-textfield>

									<tui-error
										[order]="['required']"
										formControlName="minDate"
									/>
								</label>

								<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
								<label tuiLabel class="flex-1">
									{{
										'analyses.dialog.edit-analysis.time-period.max-date'
											| transloco: { count: $index + 1 }
									}}

									<tui-textfield tuiTextfieldSize="m">
										<input
											tuiInputDate
											formControlName="maxDate"
											[min]="
												formGroup.get('minDate')
													?.value ?? minDate
											"
											[max]="
												$last
													? null
													: (timePeriods
															.at($index + 1)
															.get('minDate')
															?.value ?? maxDate)
											"
											placeholder="{{
												'analyses.dialog.create-analysis.time-period.date-placeholder'
													| transloco
											}}"
										/>
										<tui-calendar *tuiDropdown />
									</tui-textfield>

									<tui-error
										[order]="['required']"
										formControlName="maxDate"
									/>
								</label>

								<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
								<label tuiLabel class="w-full flex-1">
									{{
										'analyses.dialog.edit-analysis.time-period.overhead-costs'
											| transloco: { count: $index + 1 }
									}}

									<tui-textfield tuiTextfieldSize="m">
										<input
											tuiInputNumber
											formControlName="overheadCosts"
											[placeholder]="
												'analyses.dialog.create-analysis.time-period.cost-placeholder'
													| transloco
											"
											[tuiNumberFormat]="{
												thousandSeparator: ',',
											}"
											[min]="0"
											[prefix]="
												form.get('currency')?.value
													| currencySymbol
											"
										/>
									</tui-textfield>

									<tui-error
										[order]="['required']"
										formControlName="overheadCosts"
									/>
								</label>
							</div>
						}
					}
				}

				<label tuiLabel class="w-full max-w-56">
					{{
						'analyses.dialog.edit-analysis.cost-type.label'
							| transloco
					}}

					<tui-textfield
						tuiChevron
						tuiTextfieldSize="m"
						[content]="content"
					>
						<input
							formControlName="costType"
							tuiSelect
							[placeholder]="
								'analyses.dialog.edit-analysis.cost-type.placeholder'
									| transloco
							"
						/>

						<tui-data-list-wrapper
							new
							*tuiDropdown
							[items]="costTypes"
							[itemContent]="content"
						/>

						<ng-template #content let-value>
							{{
								'analyses.dialog.edit-analysis.cost-type.' +
									value | transloco
							}}
						</ng-template>
					</tui-textfield>

					<tui-error
						[order]="['required']"
						formControlName="costType"
					/>
				</label>
			</form>
		}
	</section>

	<footer tuiFooter>
		<button tuiButton size="s" appearance="outline" (click)="onDismiss()">
			{{ 'action.cancel' | transloco }}
		</button>

		<button
			tuiButton
			size="s"
			type="button"
			[disabled]="form?.invalid"
			(click)="onSubmit()"
			[loading]="busy"
		>
			{{ 'analyses.action.update-analysis' | transloco }}
		</button>
	</footer>
</tui-loader>
